import {HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ApiService} from '@drl/core/api/api.service';
import {
  GetCareCentralChatMessageCommand,
  FetchDashboardMsgCountCommand,
  GetCareCentralChatMessagesCountCommand
} from '@drl/shared/commands';
import {Observable, of} from 'rxjs';

import {MessagesAdapter} from '../adapters/messages-adapter.service';
import {CategoryWiseMessageDto} from '../models/categorywise-message.dto.model';
import {CategoryWiseMessageCountDto} from '../models/categorywise-message-count.dto.model';

import {DashboardMsgDateDto, PatientUnreadMessageSummaryDto} from '../models/msg-dashboard-count.dto.model';
import {AnyAdapter} from '@drl/core/api/adapters/any-adapter.service';
import { GetChatMessageCountCommand } from 'src/app/main/patients/chat/commands';
import { Count } from '@drl/core/models';

const sortOrderDesc = 'lastChat DESC';
const meggasesCount=50;
@Injectable()
export class MessagesCareCentralFacadeService {
  constructor(
    private readonly apiService: ApiService,
    private readonly msgAdapter: MessagesAdapter,
    private readonly anyAdapter: AnyAdapter,
  ) {}

  getChatMessages(
    start?: string,
    end?: string,
    caregroupId?: number,
  ): Observable<PatientUnreadMessageSummaryDto[]> {
    const command: GetCareCentralChatMessageCommand<PatientUnreadMessageSummaryDto> =
      new GetCareCentralChatMessageCommand(this.apiService, this.msgAdapter);

    const order = [sortOrderDesc];
    const queryData = {
      caregroupId: undefined,
    };

    if (caregroupId) {
      queryData.caregroupId = caregroupId;
    }

    const queryStr = JSON.stringify({
      where: queryData,
      order,
    });

    let params = new HttpParams();
    params = params.set('start', start);
    params = params.set('end', end);
    params = params.set('filter', queryStr);
    if(Intl.DateTimeFormat().resolvedOptions().timeZone != 'Etc/Unknown'){
      params = params.set('timeZone', Intl.DateTimeFormat().resolvedOptions().timeZone)
    } else {
      // default time zone in brazil -3 if system unable to detect timezone
      params = params.set('timeZone', 'America/Bahia')
    }

    command.parameters = {
      query: params,
    };
    return command.execute();
  }

  getChatMessagesByPatientIds(
    name: string,
    limit=meggasesCount,
    offset=0,
    patientIds?: number[],
  ): Observable<PatientUnreadMessageSummaryDto[]> {
    const command: GetCareCentralChatMessageCommand<PatientUnreadMessageSummaryDto> =
      new GetCareCentralChatMessageCommand(this.apiService, this.msgAdapter);
    let params = new HttpParams();
    params = params.set('offset', ''+offset);
    params = params.set('limit', ''+limit);
    params = params.set('name', name);
    if(Intl.DateTimeFormat().resolvedOptions().timeZone != 'Etc/Unknown'){
      params = params.set('timeZone', Intl.DateTimeFormat().resolvedOptions().timeZone)
    } else {
      // default time zone in brazil -3 if system unable to detect timezone
      params = params.set('timeZone', 'America/Bahia')
    }
    if (patientIds && patientIds.length) {
      params = params.set('patientIds', JSON.stringify({patientIds}));
    } else if (patientIds && !patientIds.length) {
      return of([]);
    } else {
      // do nothing
    }
    command.parameters = {
      query: params,
    };
    return command.execute();
  }

  getChatMessagesCountByPatientIds(
    start?: string,
    end?: string,
    patientIds?: number[],
  ): Observable<CategoryWiseMessageCountDto> {
    const command: GetCareCentralChatMessagesCountCommand<CategoryWiseMessageCountDto> =
      new GetCareCentralChatMessagesCountCommand(this.apiService, this.anyAdapter);


    let params = new HttpParams();
    params = params.set('start', start);
    params = params.set('end', end);
    if(Intl.DateTimeFormat().resolvedOptions().timeZone != 'Etc/Unknown'){
      params = params.set('timeZone', Intl.DateTimeFormat().resolvedOptions().timeZone)
    } else {
      // default time zone in brazil -3 if system unable to detect timezone
      params = params.set('timeZone', 'America/Bahia')
    }
    if (patientIds && patientIds.length) {
      params = params.set('patientIds', JSON.stringify({patientIds}));
    } else if (patientIds && !patientIds.length) {
      return of(new CategoryWiseMessageCountDto());
    } else {
      // do nothing
    }
    command.parameters = {
      query: params,
    };
    return command.execute();
  }



  fetchDashboardCount(): Observable<DashboardMsgDateDto> {
    const command: FetchDashboardMsgCountCommand<DashboardMsgDateDto> =
      new FetchDashboardMsgCountCommand(this.apiService, this.anyAdapter);
      let params = new HttpParams();
      if(Intl.DateTimeFormat().resolvedOptions().timeZone != 'Etc/Unknown'){
        params = params.set('timeZone', Intl.DateTimeFormat().resolvedOptions().timeZone)
      } else {
        // default time zone in brazil -3 if system unable to detect timezone
        params = params.set('timeZone', 'America/Bahia')
      }
      command.parameters = {
        query: params,
      };
    return command.execute();
  }

  getChatMessageCount(
    name?: string,
  ): Observable<Count> {
    const command: GetChatMessageCountCommand<Count> =
      new GetChatMessageCountCommand(this.apiService, this.anyAdapter);

    

    let params = new HttpParams();
   
    if (name) {
      params = params.set('name', name);
    }
    command.parameters = {
      query: params,
    };
    return command.execute();
  }
}
